import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import FamilyMemberCard from './FamilyMemberCard';
import { FamilyMember } from '../../services/familyPlanService';

interface FamilyMemberListProps {
  members: FamilyMember[];
  onRemoveMember: (memberId: number) => void;
  isRemoving: boolean;
}

const FamilyMemberList: React.FC<FamilyMemberListProps> = ({
  members,
  onRemoveMember,
  isRemoving
}) => {
  const activeMembers = members.filter(m => m.status === 'active' || m.status === 'pending');

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          Family Members ({activeMembers.length})
        </CardTitle>
      </CardHeader>
      <CardContent>
        {activeMembers.length === 0 ? (
          <p className="text-muted-foreground text-center py-8">
            No family members added yet. Add members using the form above.
          </p>
        ) : (
          <div className="space-y-3">
            {activeMembers.map((member) => (
              <FamilyMemberCard
                key={member.id}
                member={member}
                onRemove={onRemoveMember}
                isRemoving={isRemoving}
              />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default FamilyMemberList;
